import { createSlice } from '@reduxjs/toolkit';
import {
  AppDispatch,
  GetState,
  RootState,
  Screens,
  UpdateMetaArgs,
} from './types';
import metaScreenConfig from './meta-config/screens';
import metaTargetConfig from './meta-config/targets';
import { logClientDataPoint } from '../helpers/client-diagnostics';
import { selectExperiments } from './experiments';

export const metaState = createSlice({
  name: 'meta',
  initialState: {
    screen: Screens.LandingRouter,
    ...metaScreenConfig[Screens.LandingRouter],
  },
  reducers: {
    setMeta: (state, action) => {
      state.screen = action.payload.screen;
      state.canGoBack = action.payload.canGoBack;
      state.stepTitleIsNotPHI = action.payload.stepTitleIsNotPHI;
      state.subTitle = action.payload.subTitle;
      state.label = action.payload.label;
      state.subLabel = action.payload.subLabel;
      state.type = action.payload.type;
      state.options = action.payload.options;
      state.canRewrite = action.payload.canRewrite;
      state.secondaryText = action.payload.secondaryText;
      state.step = action.payload.step;
      state.isTerminate = action.payload.isTerminate;
      state.section = action.payload.section;
      state.review = state.review || action.payload.review;
      state.hasPreviouslyCompletedAssessment =
        state.hasPreviouslyCompletedAssessment || action.payload.review;
      state.assessmentSection = action.payload.assessmentSection;
      state.isSectionIntro = action.payload.isSectionIntro;
    },
    setReview: state => {
      state.review = true;
    },
    setLabel: (state, action) => {
      state.label = action.payload;
    },
    setSublabel: (state, action) => {
      state.subLabel = action.payload;
    },
    setHasPreviouslyCompletedAssessment: (state, action) => {
      state.hasPreviouslyCompletedAssessment = action.payload;
    },
  },
});

export const {
  setMeta,
  setReview,
  setLabel,
  setSublabel,
  setHasPreviouslyCompletedAssessment,
} = metaState.actions;

export const selectMeta = (state: RootState) => state.meta;
export const selectPresentMeta = (state: RootState) => state.meta.present;
export const isInReview = (state: RootState) => state.meta.present.review;
export const selectHasPreviouslyCompletedAssessment = (state: RootState) =>
  state.meta.present.hasPreviouslyCompletedAssessment;

export const updateMeta =
  ({ screen, ...nonStateContext }: UpdateMetaArgs = {}) =>
  (dispatch: AppDispatch, getState: GetState): void => {
    const state = getState();
    let nextScreen = screen;
    if (!nextScreen) {
      // Debugging TAP-2429
      if (
        !state.meta.present.screen ||
        !(state.meta.present.screen in metaTargetConfig)
      ) {
        logClientDataPoint('meta_present_screen_error', {
          meta: state.meta.present,
          metaTargetConfig,
        });
      }
      const getTarget = metaTargetConfig[state.meta.present.screen];
      nextScreen = getTarget(state, nonStateContext);
    }
    const nextMeta = { ...metaScreenConfig[nextScreen], screen: nextScreen };

    const { ab_test_intro_screens } = selectExperiments(state) as any;

    if (
      nextMeta.screen === 'introScreenFour' &&
      ab_test_intro_screens?.ab_test_intro_screens?.value
    ) {
      dispatch(setMeta({ ...nextMeta, canGoBack: false }));
    } else {
      dispatch(setMeta(nextMeta));
    }
  };

export default metaState.reducer;
